// CB:BEGIN sanitize-cached-usertype
/** Allowed Clerk publicMetadata usertype values (lowercase). Stale cache must not invent roles. */
const ALLOWED = new Set(['homeowner', 'contractor', 'admin', 'realtor', 'property_manager']);

export function sanitizeCachedUsertype(raw: string | null | undefined): string | null {
  if (!raw || typeof raw !== 'string') return null;
  const v = raw.trim().toLowerCase();
  return ALLOWED.has(v) ? v : null;
}
// CB:END sanitize-cached-usertype
